// Spice Pilgrim mega menu. CSS :hover handles show/hide visuals via
// transition-delay (hover intent). JS adds keyboard support, click-outside
// close, and right-edge viewport detection.

(function () {
  'use strict';

  var items = document.querySelectorAll('.sp-nav__item--mega');
  if (!items.length) return;

  items.forEach(function (item) {
    var link = item.querySelector('.sp-nav__link');
    var panel = item.querySelector('.sp-mega-panel');
    if (!link || !panel) return;

    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var isOpen = panel.getAttribute('aria-hidden') === 'false';
        setOpen(link, panel, !isOpen);
      } else if (e.key === 'Escape') {
        setOpen(link, panel, false);
        link.focus();
      }
    });

    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setOpen(link, panel, false);
        link.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) setOpen(link, panel, false);
    });

    item.addEventListener('mouseenter', function () {
      adjustEdge(panel);
    });
  });

  function setOpen(link, panel, open) {
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    link.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) adjustEdge(panel);
  }

  function adjustEdge(panel) {
    panel.style.transform = '';
    var rect = panel.getBoundingClientRect();
    var overflow = rect.right - window.innerWidth;
    if (overflow > 0) {
      panel.style.transform = 'translateX(-' + Math.ceil(overflow + 16) + 'px)';
    }
  }
}());
